<template>
  <campaign-table :company-id="companyId" />
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_COMPANY_MANAGEMENT_DATA } from "@/core/services/store/company_management.module";
import CampaignTable from "@/view/pages/campaign/CampaignTable.vue";

export default {
  name: "CompanyManagementCampaign",
  components: { CampaignTable },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    }
  },
  async mounted() {
    let companyName = `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`;
    try {
      const { data } = await this.$store.dispatch(GET_COMPANY_MANAGEMENT_DATA, {
        id: this.companyId
      });
      if (data.status === "success" && data.data && data.data.name) {
        companyName = `${data.data.name}`;
      }
    } catch (_) {
      // fallback to default title
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
        route: "/company-management"
      },
      { title: companyName }
    ]);
  }
};
</script>
